import React, { useContext, useEffect, useState } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import TeamWork from './teamWork/index';
import Efficiency from './efficiency/index';
import Auth from './auth/index';
import AuthContext from '../contexts/AuthContext';
import CircularProgress from '../components/CircularProgress';

const App = (props: any) => {
  const match = props.match;
  const authContext = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
  }, [authContext]);

  useEffect(() => {
    if (loading) setLoading(false);
  }, [loading]);

  return (
    <div className="gx-main-content-wrapper-10-5-0">
      {/* <div className="gx-main-content-wrapper"> */}
      {loading ? (
        <div className="gx-main-content-wrapper">
          <CircularProgress className="" />
        </div>
      ) : (
        <Switch>
          <Redirect exact from={`${match.url}`} to={`${match.url}team-work`} />
          <Route path={`${match.url}team-work`} component={TeamWork} />
          <Route path={`${match.url}efficiency`} component={Efficiency} />
          <Route path={`${match.url}auth`} component={Auth} />
        </Switch>
      )}
    </div>
  );
};

export default App;
